import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import CanonicalLink from 'ecosystem-marketplace-core/components/elements/CanonicalLink';
import { useCanonicalUrl } from '../../../hooks/useCanonicalUrl';

function StorefrontCanonicalLinks({
  pageCount,
  routeParams
}) {
  const {
    pageNumber
  } = routeParams;
  const canonicalUrl = useCanonicalUrl();
  const nextPageUrl = useCanonicalUrl(pageNumber + 1);
  const prevPageUrl = useCanonicalUrl(pageNumber - 1);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(CanonicalLink, {
      rel: "canonical",
      href: canonicalUrl
    }), pageNumber < pageCount && /*#__PURE__*/_jsx(CanonicalLink, {
      rel: "next",
      href: nextPageUrl
    }), pageNumber > 1 && /*#__PURE__*/_jsx(CanonicalLink, {
      rel: "prev",
      href: prevPageUrl
    })]
  });
}

export default StorefrontCanonicalLinks;